import { Component, Inject, OnInit } from '@angular/core';
import { GETDashboardComponentHistroyInspectionVM } from '../../../../../../../app/modules/GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { DigitalFormService } from '../../../../../../../app/modules/GET_NEW_UI/digital-form-fill/digital-form.service';
import { PreferencesService } from '../../../../../../modules/preferences/preferences.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-component-histroy-dialog',
  templateUrl: './component-histroy-dialog.component.html',
  styleUrls: ['./component-histroy-dialog.component.scss']
})
export class ComponentHistroyDialogComponent implements OnInit {

  ComponentId:number;
 historyList:GETDashboardComponentHistroyInspectionVM[];

 System:string
 CompName:string
  constructor(private _dialogRef: MatDialogRef<ComponentHistroyDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formService:DigitalFormService,
    private readonly _pref: PreferencesService,
    private _router: Router,) { }

    ngOnInit() {
      this.ComponentId=this._data.ComponentId;
      this.System =this._data.System;
      if(this.ComponentId>0){
        
        this._formService.GetComponentHistroyForGETDashboard(this.ComponentId).subscribe(res=>{
          this.historyList = res;
          if(this.historyList.length>0){
            this.CompName = this.historyList[0].CompName;
          }
          
        })
      }
      
    }
    onNoClick(){
      
      this._dialogRef.close(false);
    }

    OpenInspection(comp:GETDashboardComponentHistroyInspectionVM){

     // window.open('digitalform/fill/'+ comp.FormId+ '/'+ comp.UploadId+ '/'+ comp.CatId+ '/'+comp.QId,'_blank');

      this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
        if(res=="True"){
          this._router.navigate(['/digitalform/fill/', comp.FormId, comp.UploadId, comp.CatId, comp.QId ]);
        }else{             
          window.open('digitalform/fill/'+ comp.FormId+ '/'+ comp.UploadId+ '/'+ comp.CatId+ '/'+comp.QId,'_blank');
         
        }
    });

    }
}
